import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-launch",
  "use": "icon-launch-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:serif=\"http://www.serif.com/\" id=\"icon-launch\"><path d=\"M3,3l0,18l18,0l0,-9l-2,0l0,7l-14,0l0,-14l7,0l0,-2l-9,0Zm11,0l0,2l3.586,0l-9.293,9.293l1.414,1.414l9.293,-9.293l0,3.586l2,0l0,-7l-7,0Z\" style=\"fill:#ed6b1c;fill-rule:nonzero;\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol